import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Input, InputNumber, Upload, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { SelectF } from '@/i2antdV5'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'

const FormItem = Form.Item
const IMAGE_MAX_MB = 5
const COVER_MIME = {
  'image/jpeg': true,
  'image/png': true,
  'image/gif': true,
  'image/webp': true
}

function normUploadFileList (e) {
  if (Array.isArray(e)) return e
  return e && e.fileList ? e.fileList : []
}

class ProjectForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    getJStoreList: PropTypes.object,
    projectList: PropTypes.object,
    dispatch: PropTypes.func
  }

  componentDidMount () {
    const { dispatch, getJStoreList } = this.props
    const storeOptions = getJStoreList.data
    if (!Array.isArray(storeOptions) || storeOptions.length === 0) {
      dispatch(fetchJStoreList({ query: {}, dataType: 'optionTuina' }))
    }
    this.syncRecord()
  }

  componentDidUpdate (prevProps) {
    const prevId = prevProps.record && prevProps.record.id
    const nextId = this.props.record && this.props.record.id
    if (prevProps.actType !== this.props.actType || prevId !== nextId) {
      this.syncRecord()
      return
    }
    const prevList = prevProps.getJStoreList.data
    const nextList = this.props.getJStoreList.data
    const prevEmpty = !Array.isArray(prevList) || prevList.length === 0
    const nextHas = Array.isArray(nextList) && nextList.length > 0
    if (prevEmpty && nextHas) this.syncRecord()
  }

  syncRecord = () => {
    const { form, actType, record, projectList, getJStoreList } = this.props
    if (!form || !form.current) return
    const storeOptions = getJStoreList.data
    const firstStore = Array.isArray(storeOptions) && storeOptions[0]
    const firstStoreId = firstStore && firstStore.id != null && firstStore.id !== ''
      ? String(firstStore.id)
      : undefined
    const values = {
      durationMinutes: 60,
      sortOrder: 0,
      cover: [],
      storeId: firstStoreId
    }
    const queryStoreId = projectList.query.storeId
    if (queryStoreId != null && queryStoreId !== '') {
      values.storeId = String(queryStoreId)
    }
    if (actType === 'edit' && record) {
      const coverUrl = record.coverUrl
      values.storeId = record.storeId == null || record.storeId === ''
        ? undefined
        : String(record.storeId)
      values.name = record.name
      values.durationMinutes = record.durationMinutes
      values.price = record.price
      values.description = record.description
      values.sortOrder = record.sortOrder
      values.cover = coverUrl
        ? [{ uid: '-1', name: 'cover', status: 'done', url: coverUrl }]
        : []
    }
    form.current.setFieldsValue(values)
  }

  beforeUploadImage = (file) => {
    const type = file && file.type ? String(file.type) : ''
    if (!COVER_MIME[type]) {
      message.error('仅支持 jpg / png / gif / webp')
      return Upload.LIST_IGNORE
    }
    const sizeMb = file.size / 1024 / 1024
    if (sizeMb >= IMAGE_MAX_MB) {
      message.error(`图片不能超过 ${IMAGE_MAX_MB}MB`)
      return Upload.LIST_IGNORE
    }
    return false
  }

  render () {
    const { form, actType, getJStoreList } = this.props
    const storeOptions = getJStoreList.data
    return (
      <Form ref={form} layout="vertical">
        <FormItem
          label="门店"
          name="storeId"
          rules={[{ required: true, message: '请选择门店' }]}
        >
          <SelectF
            options={storeOptions}
            modalProps={{
              size: 'large',
              placeholder: '请选择门店',
              disabled: actType === 'edit'
            }}
          />
        </FormItem>
        <FormItem noStyle shouldUpdate={(prev, cur) => prev.cover !== cur.cover}>
          {() => {
            const fileList = (form && form.current && form.current.getFieldValue('cover')) || []
            return (
              <FormItem
                label="封面图"
                name="cover"
                valuePropName="fileList"
                getValueFromEvent={normUploadFileList}
                extra="支持 jpg / png / gif / webp，最多 1 张，不超过 5MB"
              >
                <Upload
                  listType="picture-card"
                  maxCount={1}
                  accept="image/jpeg,image/png,image/gif,image/webp"
                  beforeUpload={this.beforeUploadImage}
                >
                  {fileList.length >= 1 ? null : (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>上传</div>
                    </div>
                  )}
                </Upload>
              </FormItem>
            )
          }}
        </FormItem>
        <FormItem
          label="名称"
          name="name"
          rules={[{ required: true, message: '请填写名称' }]}
        >
          <Input size="large" placeholder="如 保健推拿" maxLength={128} />
        </FormItem>
        <FormItem
          label="服务描述"
          name="description"
        >
          <Input.TextArea
            rows={3}
            size="large"
            placeholder="选填"
            allowClear
            maxLength={512}
            showCount
          />
        </FormItem>
        <FormItem
          label="时长"
          name="durationMinutes"
          rules={[{ required: true, message: '请填写时长' }]}
        >
          <InputNumber size="large" min={1} precision={0} addonAfter="分钟" style={{ width: '100%' }} />
        </FormItem>
        <FormItem
          label="价格"
          name="price"
          rules={[{ required: true, message: '请填写价格' }]}
        >
          <InputNumber size="large" min={0} precision={2} addonAfter="元" style={{ width: '100%' }} />
        </FormItem>
        <FormItem
          label="排序"
          name="sortOrder"
          extra="数字越小越靠前。"
        >
          <InputNumber size="large" precision={0} style={{ width: '100%' }} />
        </FormItem>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  getJStoreList: state.components.getJStoreList,
  projectList: state.tuina.projectList
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(ProjectForm)
